import * as httpHelper from '../../utils/http-helper';

function buscarCompetencias(cpf: string) {
  const headers = httpHelper.defaultHeaders();

  return httpHelper.get(
    headers,
    `ExtratoRepasseCompetenciasExterna?_cpf=${
      cpf
    }&_idTipoInfo=2`
  );
}

function buscarLotacoes(cpf: string, competencia: string) {
  const headers = httpHelper.defaultHeaders();

  return httpHelper.get(
    headers,
    `ExtratoRepasseLotacoesExterna?_cpf=${
      cpf
    }&_competencia=${
      competencia
    }&_idTipoInfo=2`
  );
}

function buscarFolhas(
  idLotacao: string,
  competencia: string,
  cpf: string
) {
  const headers = httpHelper.defaultHeaders();

  return httpHelper.get(
    headers,
    `ExtratoRepasseFolhasExterna?_cpf=${
      cpf
    }&_competencia=${
      competencia
    }&_idLotacao=${
      idLotacao
    }&_idTipoInfo=2`
  );
}

function selecionarAdmissao(idCooperado: number) {
  const headers = httpHelper.defaultHeaders();

  return httpHelper.get(
    headers,
    `Cooperado/SelecionarAdmissao?_idCooperado=${idCooperado}`
  );
}

function selecionarCategoria(idCooperado: number) {
  const headers = httpHelper.defaultHeaders();

  return httpHelper.get(
    headers,
    `Cooperado/SelecionarCategoria?_idCooperado=${idCooperado}`
  );
}

function buscarExtratoFolha(
  cpf: string,
  idLotacao: string,
  competencia: string,
  idControleFolha: string
) {
  const headers = httpHelper.defaultHeaders();

  return httpHelper.get(
    headers,
    `ExtratoRepasseExterna?_cpf=${
      cpf
    }&_competencia=${
      competencia
    }&_idLotacao=${
      idLotacao
    }&_idControleFolha=${
      idControleFolha
    }&_idTipoInfo=2`
  );
}

const extratoRepasseExternoService = {
  buscarFolhas,
  buscarLotacoes,
  buscarCompetencias,
  selecionarAdmissao,
  selecionarCategoria,
  buscarExtratoFolha,
}

export default extratoRepasseExternoService;
